import { Text } from '@chakra-ui/react';

import { Link } from '~/components/link';

export function StandardLegalCopy({ submitButtonLabel }: { submitButtonLabel: string }) {
  return (
    <Text size='caption'>
      By clicking &quot;{submitButtonLabel},&quot; I consent and agree to receive marketing communications from Udacity,
      which may include email messages, text messages, and phone calls from Udacity to the email and phone number listed
      above. Call and message rates may apply. I also acknowledge that my data will be used in accordance with the
      Udacity{' '}
      <Link fontSize='inherit' fontWeight='inherit' href='/legal/en-us/terms-of-use' isExternal>
        Terms of Use
      </Link>{' '}
      and{' '}
      <Link fontSize='inherit' fontWeight='inherit' href='/legal/privacy' isExternal>
        Privacy Policy
      </Link>
      , including relevant opt-out provisions therein.
    </Text>
  );
}
